import React from 'react';
import styled from 'styled-components';
import { GhostButton } from '@ui/buttons';
import { Body7, Container } from '@ui';
import { formatFeedId } from './format';

const Trail = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

// Every item in the trail is a flex box with the same line box: a bare <button> next to a bare
// <span> gives each a different content height, which is what left the crumbs sitting a pixel off
// their separators.
const item = `
  display: inline-flex;
  align-items: center;
  line-height: 1;
  min-width: 0;
`;

const Crumb = styled(GhostButton)`
  ${item};
  color: ${({ theme }) => theme.themeColors.primaryCtaButton};

  &:hover {
    text-decoration: underline;
  }
`;

// Optically centred rather than baseline-aligned: the chevron glyph sits high in its em box.
const Separator = styled.span`
  ${item};
  color: ${({ theme }) => theme.themeColors.secondaryText};
  font-size: 12px;
  opacity: 0.7;
`;

const Current = styled.span`
  ${item};
`;

// Where you are, and the way back. Only the ancestors are links; the feed you're looking at is
// plain text, since clicking it would do nothing.
export const DrillDownBreadcrumb = ({ stack, currentFeedId, onNavigate }) => {
  if (!stack || stack.length === 0) return null;

  return (
    <Container bottom={16}>
      <Trail aria-label="Feed drill-down path">
        {stack.map((entry, depth) => (
          <React.Fragment key={`${entry.feedId}-${depth}`}>
            <Crumb type="button" onClick={() => onNavigate(depth)}>
              <Body7 bold>{formatFeedId(entry.feedId)}</Body7>
            </Crumb>
            <Separator aria-hidden="true">›</Separator>
          </React.Fragment>
        ))}
        <Current aria-current="page">
          <Body7 bold>{formatFeedId(currentFeedId)}</Body7>
        </Current>
      </Trail>
    </Container>
  );
};
